import {
  AfterViewInit, Component,
  Directive, ElementRef,
  HostBinding, Inject,
  Injector,
  Optional, SkipSelf
} from '@angular/core';
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {WizardComponent} from "../wizard.component";
import {get, noop} from "lodash-es";
import {WmsTranscludeDirective} from "../../../page/wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-wizard-step-content';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-wizardstep',
  hostClass: DEFAULT_CLS
};

const enum STEP_STATUS {
  CURRENT = 1,
  DISABLED
}

@Component({
  selector: 'form[wmWizardstep]',
  template: `
    <div class="panel-body" page-container-target partial-container-target wmsTransclude>
      <ng-content></ng-content>
    </div>`,
  providers: [
    provideAsWidgetRef(WizardstepComponent)

  ],
  standalone: true,
  imports: [
    WmsTranscludeDirective
  ],
  exportAs: 'wmWizardstep'
})
export class WizardstepComponent extends StylableComponent{
  static initializeProps = register('wm-wizardstep');

  public show: boolean;
  public name: string;
  public enableskip: any;
  public disabledone: boolean;
  public isInitialized: boolean;
  public iconclass: string;
  public doneiconclass: string;
  public title: string;
  public subtitle: string;

  private status: any = STEP_STATUS.DISABLED;
  private class: string | null;
  $lazyLoad: Function = noop;

  @HostBinding('class.current')
  get isCurrent(){
    return this.isActive
  }
  public set isActive(nv: boolean) {
    this.status = STEP_STATUS.CURRENT;
  }

  public get isActive(): boolean {
    return this.status === STEP_STATUS.CURRENT;
  }


  public set disabled(nv: boolean) {
    if (nv) {
      this.status = STEP_STATUS.DISABLED;
    }
  }

  public get disabled(): boolean {
    return this.status === STEP_STATUS.DISABLED;
  }

  public get enableDone() {
    return !this.disabledone;
  }

  constructor(inj: Injector,
              @SkipSelf() @Optional() private _viewParent: WizardComponent,
              @SkipSelf() @Inject(ElementRef) public _el: any) {
    super(inj, WIDGET_CONFIG, _viewParent);
    styler(this.nativeElement, this);
  }

  override onPropertyChange(key: string, nv: any, ov?: any){
    if (key === 'show') {
      this.class = this.getParentScope().getNativeElement().getAttribute('class')
      this.widgetProps['iconclass'].show = !!this.class?.includes('iconstepper');
      this.widgetProps['doneiconclass'].show = !!this.class?.includes('iconstepper');
    } else if (key === 'content') {
        setTimeout(() => this.$lazyLoad(), 100);
    }
    super.onPropertyChange(key, nv, ov);
  }

  private getParentScope(): WizardComponent {
    return this._viewParent || this._el.nativeElement.widget || get($(this.nativeElement).closest('[widgettype="wm-wizard"]')[0], 'widget');
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    this.getParentScope().addWizardStep(this)
  }

}

